import request from './request'

/**
 * 提交反馈建议
 */
export const submitFeedback = (data) => {
    return request.post('/core/messages/', data)
}

/**
 * 获取我的反馈历史列表
 */
export const getMyFeedbackList = (params) => {
    return request.get('/core/messages/me', { params })
}

/**
 * 获取反馈详情
 */
export const getFeedbackDetail = (id) => {
    return request.get(`/core/messages/${id}`)
}
